export default {"src":"/_next/static/media/video-camera.2814c5aa.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};